import { cva } from '@/styled-system/css';

export const comboboxOptionRecipe = cva({
  base: {
    'display': 'block',
    'paddingBlock': 'tight',
    'paddingInline': 'default',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: '{background-color 200ms ease}',
    },
    'width': '100%',
    'backgroundColor': { base: 'bg.elevated.mediumShadow' },

    '&:has([data-c11n-component="Combobox.OptionMedia"])': {
      display: 'grid',
      gridTemplate: `
        "media label" auto
        "media meta" auto / auto auto
      `,
      justifyContent: 'start',
      columnGap: 'tighter',
    },

    '& [data-c11n-component="Highlight"]': {
      textStyle: 'body-bold',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        cursor: 'pointer',
        backgroundColor: {
          base: 'bg.elevated.mediumShadow',
          _hover: 'bg.action.neutral.alt.hover',
          _active: 'bg.action.neutral.alt.pressed',
        },
      },
    },
    active: {
      true: {},
      false: {},
    },
    selected: {
      true: {
        backgroundColor: { base: 'bg.elevated.mediumShadow' },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      active: true,
      css: {
        backgroundColor: { base: 'bg.action.neutral.alt.hover' },
      },
    },
  ],
});
